import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Product, User } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { UigMediaService } from 'src/app/services/uig-media.service';
import { UigShopViewService } from 'src/app/services/uig-shop-view.service';
import {UserAccountFacade} from '@spartacus/user/account/root';

@Component({
    selector: 'app-uig-product-prices',
    templateUrl: './uig-product-prices.component.html',
    styleUrls: ['./uig-product-prices.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigProductPricesComponent implements OnInit{

  product$: Observable<Product> = this.currentProductService.getProduct();
  SHOW_BESTPRICE = 'show_bestprice';
  showBestPrice: boolean = true;
  hasShopViewUserRole: boolean = true;

  showDiscounts = false;
  mediaService = this.uigMediaService;
  constructor(private currentProductService: CurrentProductService,
    private uigMediaService: UigMediaService,private userAccountFacade: UserAccountFacade,private uigShopViewService:UigShopViewService) {
    }

    ngOnInit(): void {
    this.uigShopViewService.isShopViewMode().subscribe((hasRole) =>{
      this.hasShopViewUserRole = hasRole;
    })
      this.userAccountFacade
        .get()
        .pipe(filter((user: User) => user && Object.keys(user).length > 0))
        .subscribe((user) => {
          const hasRole =
            user.roles && user.roles.includes(this.SHOW_BESTPRICE);
          if (hasRole) {
            this.showBestPrice = this.showBestPrice && true;
          } else {
            this.showBestPrice = this.showBestPrice && false;
          }
        });

      this.product$
        .pipe(
          tap((data) => {
            this.showBestPrice = this.showBestPrice && data?.bestPrice != null;
          })
        )
        .subscribe();
  }

  toggleDiscounts(show:boolean) {
    this.showDiscounts = show;
  }

}
